// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:base-models --tenant projectReplica` to regenerate.
import DatabaseRecord from "velocious/build/src/database/record/index.js"

/**
 * Attributes accepted when creating or updating Comment records.
 * @typedef {object} CommentWriteAttributes
 * @property {string} [id] - Value for the id attribute.
 * @property {string | null} [userId] - Value for the userId attribute.
 * @property {string | null} [resourceType] - Value for the resourceType attribute.
 * @property {string | null} [resourceId] - Value for the resourceId attribute.
 * @property {number | null} [idPerResource] - Value for the idPerResource attribute.
 * @property {string | null} [comment] - Value for the comment attribute.
 * @property {string | null} [automationKind] - Value for the automationKind attribute.
 * @property {Date | string} [createdAt] - Value for the createdAt attribute.
 * @property {Date | string} [updatedAt] - Value for the updatedAt attribute.
 * @property {Date | string | null} [lastSyncChangeAt] - Value for the lastSyncChangeAt attribute.
 */

/** @augments {DatabaseRecord<CommentWriteAttributes>} */
export default class CommentBase extends DatabaseRecord {
  /** @returns {typeof import("../models/comment.js").default} */
  // @ts-ignore - override narrows return type for better IntelliSense in generated model bases
  getModelClass() { return /** @type {typeof import("../models/comment.js").default} */ (this.constructor) }

  /** @returns {string} */
  id() { return this.readAttribute("id") }

  /**
   * @param {string} newValue
   * @returns {void}
   */
  setId(newValue) { return this._setColumnAttribute("id", newValue) }

  /** @returns {boolean} */
  hasId() { return this._hasAttribute(this.id()) }

  /** @returns {string | null} */
  userId() { return this.readAttribute("userId") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setUserId(newValue) { return this._setColumnAttribute("userId", newValue) }

  /** @returns {boolean} */
  hasUserId() { return this._hasAttribute(this.userId()) }

  /** @returns {string | null} */
  resourceType() { return this.readAttribute("resourceType") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setResourceType(newValue) { return this._setColumnAttribute("resourceType", newValue) }

  /** @returns {boolean} */
  hasResourceType() { return this._hasAttribute(this.resourceType()) }

  /** @returns {string | null} */
  resourceId() { return this.readAttribute("resourceId") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setResourceId(newValue) { return this._setColumnAttribute("resourceId", newValue) }

  /** @returns {boolean} */
  hasResourceId() { return this._hasAttribute(this.resourceId()) }

  /** @returns {number | null} */
  idPerResource() { return this.readAttribute("idPerResource") }

  /**
   * @param {number | null} newValue
   * @returns {void}
   */
  setIdPerResource(newValue) { return this._setColumnAttribute("idPerResource", newValue) }

  /** @returns {boolean} */
  hasIdPerResource() { return this._hasAttribute(this.idPerResource()) }

  /** @returns {string | null} */
  comment() { return this.readAttribute("comment") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setComment(newValue) { return this._setColumnAttribute("comment", newValue) }

  /** @returns {boolean} */
  hasComment() { return this._hasAttribute(this.comment()) }

  /** @returns {string | null} */
  automationKind() { return this.readAttribute("automationKind") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setAutomationKind(newValue) { return this._setColumnAttribute("automationKind", newValue) }

  /** @returns {boolean} */
  hasAutomationKind() { return this._hasAttribute(this.automationKind()) }

  /** @returns {Date} */
  createdAt() { return this.readAttribute("createdAt") }

  /**
   * @param {Date | string} newValue
   * @returns {void}
   */
  setCreatedAt(newValue) { return this._setColumnAttribute("createdAt", newValue) }

  /** @returns {boolean} */
  hasCreatedAt() { return this._hasAttribute(this.createdAt()) }

  /** @returns {Date} */
  updatedAt() { return this.readAttribute("updatedAt") }

  /**
   * @param {Date | string} newValue
   * @returns {void}
   */
  setUpdatedAt(newValue) { return this._setColumnAttribute("updatedAt", newValue) }

  /** @returns {boolean} */
  hasUpdatedAt() { return this._hasAttribute(this.updatedAt()) }

  /** @returns {Date | null} */
  lastSyncChangeAt() { return this.readAttribute("lastSyncChangeAt") }

  /**
   * @param {Date | string | null} newValue
   * @returns {void}
   */
  setLastSyncChangeAt(newValue) { return this._setColumnAttribute("lastSyncChangeAt", newValue) }

  /** @returns {boolean} */
  hasLastSyncChangeAt() { return this._hasAttribute(this.lastSyncChangeAt()) }

  /**
   * @returns {import("velocious/build/src/database/record/index.js").default}
   */
  resource() { return /** @type {import("velocious/build/src/database/record/index.js").default} */ (this.getRelationshipByName("resource").loaded()) }

  /**
   * @abstract
   * @param {ConstructorParameters<typeof import("velocious/build/src/database/record/index.js").default>[0]} [attributes]
   * @returns {import("velocious/build/src/database/record/index.js").default}
   */
  buildResource(attributes) { void attributes; throw new Error("Not implemented") }

  /**
   * @abstract
   * @returns {Promise<import("velocious/build/src/database/record/index.js").default | undefined>}
   */
  loadResource() { throw new Error("Not implemented") }

  /**
   * @returns {Promise<import("velocious/build/src/database/record/index.js").default | undefined>}
   */
  resourceOrLoad() { return /** @type {Promise<import("velocious/build/src/database/record/index.js").default | undefined>} */ (this.relationshipOrLoad("resource")) }

  /**
   * @abstract
   * @param {import("velocious/build/src/database/record/index.js").default} newModel
   * @returns {void}
   */
  setResource(newModel) { void newModel; throw new Error("Not implemented") }
}
